<template>
    <div class="vod-reset">
        <div class="login-form">
            <router-link to="/vod">
                <img
                    class="login-logo"
                    src="@/assets/img/logos/livekid-logo-dark.svg"
                />
            </router-link>
            <div class="login-greeting">{{ $t('LABEL_SET_NEW_PASSWORD') }}</div>
            <LoginTextInput
                color="apple"
                :dark="true"
                :errors="errors"
                :label="$t('LABEL_NEW_PASS')"
                autocomplete="password"
                icon="lock"
                name="password"
                type="password"
                v-model.trim="password"
            ></LoginTextInput>
            <div class="actions">
                <ActionButton
                    color="apple"
                    :label="$t('LABEL_RESET_PASSWORD_ACTION')"
                    :loading="loading"
                    @click="submit"
                ></ActionButton>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            errors: new this.$Errors(),
            password: ''
        }
    },
    methods: {
        submit() {
            if (this.loading) {
                return
            }
            if (!this.password) {
                this.errors.set('password')
                return
            }
            this.loading = true
            this.$api
                .post('v2/reset/confirm', {
                    token: this.$route.params.token,
                    password: this.password
                })
                .then(() => {
                    alert(this.$t('TOAST_MESSAGE_CHANGE_PASS_SUCESS'))
                    this.$router.push('/')
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.loading = false
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.vod-reset {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
